import 'reflect-metadata';
import {basicConfig} from './logging';

basicConfig();

import './global';
import './routes';
